import React from 'react';
import { getPageStaticProps } from 'lib/dato-request';
import NewHome from 'pages';
import { PARENT_LANDING_PATH } from '@/lib/defaults';


const ParentsPage = ({ data }) => {
    return <NewHome data={data} location='parents' routePath={PARENT_LANDING_PATH}/>;
};

export async function getStaticProps() {
    return getPageStaticProps('Parents');
}

export default ParentsPage;
